import { FC, useContext, useMemo } from 'react';
import { connect } from 'react-redux';

import { SectionCodes } from 'const';
import { useAppSelector, useUserFunctionality } from 'hooks';
import { IRootState } from 'reducers';
import { EventKindState } from 'reducers/employee/eventKinds';
import { sectionRefArchiveFalseSelector } from 'selectors';

import { LocalDataEntryFormContext } from '../../context/localDataEntryFormContext';
import { ActivityBlock } from '../../primaryBlocks';
import { filterActivityNameOptions } from '../../utils';

interface ICulturePrimaryBlockProps {
  eventKinds: EventKindState;
}

const CulturePrimaryBlock: FC<ICulturePrimaryBlockProps> = ({ eventKinds }) => {
  const portfolioSections = useAppSelector(sectionRefArchiveFalseSelector);
  const { isStudent, isParent } = useUserFunctionality();

  const { formData } = useContext(LocalDataEntryFormContext);

  // activity
  const activityTypeOptions = useMemo(() => {
    return portfolioSections.content.filter((section) => section.parentId === SectionCodes.cultureEvent);
  }, [portfolioSections.content]);
  const activityNameOptions = useMemo(() => {
    return filterActivityNameOptions({ eventKinds, typeCode: formData.typeCode, isStudent, isParent });
  }, [eventKinds, formData.typeCode, isStudent, isParent]);

  return (
    <>
      {formData.dataKind === SectionCodes.cultureEvent && (
        <ActivityBlock
          typeOptions={activityTypeOptions}
          nameOptions={activityNameOptions}
          nameInputLabel="Вид"
          nameInputPlaceholder="Выберите вид мероприятия..."
        />
      )}
    </>
  );
};

export default connect((state: IRootState) => ({
  eventKinds: state.eventKinds,
}))(CulturePrimaryBlock);
